import './Sidebar.scss';

import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';
import Checkbox from 'components/Checkbox';

const FILTERS = [
    {
        label: 'Last 24 Hours',
        value: 'days'
    },
    {
        label: 'Past Week',
        value: 'weeks'
    },
    {
        label: 'Past Month',
        value: 'months'
    },
    {
        label: 'Past Year',
        value: 'years'
    },
    {
        label: 'All Time',
        value: 'all'
    }
];

const Sidebar = ({selectedFilter, setFilter}) => {
    return (
        <div className="sidebar">
            <div className="sidebar__section">
                <h2 className="sidebar__title">
                    <Icon type="caret-right" /> Refine Results
                </h2>

                <div className="sidebar__filters">
                    {FILTERS.map((filter) => (
                        <Checkbox
                            label={filter.label}
                            checked={selectedFilter === filter.value}
                            id={`chkFilter${filter.label.replace(/ /g, '')}`}
                            key={filter.value}
                            name="selectedFilter"
                            onChange={() => setFilter(filter.value)}
                        />
                    ))}
                </div>
            </div>

            {/*<div className="sidebar__section">
                <h2 className="sidebar__title">
                    The difference
                </h2>
                <p>
                    easy. unique. free. lasting.
                </p>
                <p>
                    <a
                        className="c-button"
                        href="/difference"
                    >
                        How We Help
                    </a>
                </p>
            </div>*/}
        </div>
    );
};

Sidebar.propTypes = {
    selectedFilter: PropTypes.string.isRequired,
    setFilter: PropTypes.func.isRequired
};

export default Sidebar;
